/* Product page, phones only: a bar that sticks to the bottom of the screen once the main "Add to bag" button has
   scrolled up out of view, and hides again when it comes back. It mirrors the main button (same size, same price,
   Pre-order / Sold out wording, sale price) and its button simply presses the main one, so the rug pad, pre-order
   tag and PreOrder Globo all behave exactly as they do on the page. (Waise, board q-us-mobile-fixes, 2026-10-07) */
(function () {
  const bar = document.getElementById('rbAtcBar');
  const root = document.querySelector('[data-rb-product]');
  const row = root && root.querySelector('.buy-row');
  if (!bar || !row) return;
  const html = document.documentElement;
  const btn = document.getElementById('rbAtcBtn');
  const sizeEl = document.getElementById('rbAtcSize');
  const priceEl = document.getElementById('rbAtcPrice');
  const phone = matchMedia('(max-width: 760px)');

  // the button shoppers actually see in the buy row (PreOrder Globo can swap in its own on pre-order sizes)
  const mainBtn = () => [...row.querySelectorAll('button')].find((b) => !b.classList.contains('wish') && b.offsetParent !== null) || document.getElementById('rbAdd');

  function sync() {
    const m = mainBtn(); if (!m) return;
    const label = m.textContent.trim().split(' · ')[0];
    const size = [...root.querySelectorAll('[data-opt-name]')].map((s) => s.textContent.trim()).filter(Boolean).join(' · ');
    if (btn.textContent !== label) btn.textContent = label;
    btn.disabled = !!m.disabled;
    btn.setAttribute('aria-label', size ? `${label}, ${size}` : label);
    if (sizeEl.textContent !== size) sizeEl.textContent = size;
    const p = document.getElementById('price');
    if (p && priceEl.innerHTML !== p.innerHTML) priceEl.innerHTML = p.innerHTML;
  }

  let past = false; // the buy row is above the screen (scrolled past it)
  function show() {
    const on = phone.matches && past && !html.classList.contains('cmp-on');
    bar.classList.toggle('on', on);
    html.classList.toggle('atcbar-on', on);
  }

  btn.addEventListener('click', () => { const m = mainBtn(); if (m && !m.disabled) m.click(); });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => es.forEach((e) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; show(); })).observe(row);
  }
  phone.addEventListener ? phone.addEventListener('change', show) : phone.addListener(show);
  new MutationObserver(show).observe(html, { attributes: true, attributeFilter: ['class'] });

  const mo = new MutationObserver(sync);
  mo.observe(row, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'style', 'class', 'hidden'] });
  const p = document.getElementById('price'); if (p) mo.observe(p, { childList: true, subtree: true, characterData: true });
  root.querySelectorAll('[data-opt-name]').forEach((s) => mo.observe(s, { childList: true, subtree: true, characterData: true }));
  html.classList.add('has-atcbar');
  sync();
})();
